import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PhysicianProfileSidebar from "../Components/PhysicianProfileSidebar";
import { useSelector } from "react-redux";
import Norecord from "../Components/Norecord";
import Pagination from "../Components/Pagination";
import { getPhysicianappointmentsapi } from "../network/Network";

const PhysicianMyConsultations = () => {
  const token = useSelector((state) => state?.Auth?.token);
  const [clickedButton, setClickedButton] = useState("upcoming");
  const [appointmentsCache, setAppointmentsCache] = useState({
    upcoming: null,
    current: null,
    past: null,
  });
  const [currentAppointments, setCurrentAppointments] = useState([]);
  const [current_page, setCurrent_page] = useState(1);
  const [pageCount, setPageCount] = useState();

  // Button Handler
  const handleClick = (buttonName) => {
    setClickedButton(buttonName);
    setCurrent_page(1); 
  };

  // Fetch Appointments API
  useEffect(() => {
    if (appointmentsCache[clickedButton]) {
      setCurrentAppointments(appointmentsCache[clickedButton].data);
      setPageCount(appointmentsCache[clickedButton].pageCount);
      return;
    }

    getPhysicianappointmentsapi(clickedButton, token, current_page).then(
      (res) => {
        const fetchedData = res?.data?.data || [];
        const total = res?.data?.total || 0;
        const limit = res?.data?.per_page || 1;
        const totalPageCount = Math.ceil(total / limit);

        // Update the cache
        setAppointmentsCache((prevCache) => ({
          ...prevCache,
          [clickedButton]: { data: fetchedData, pageCount: totalPageCount },
        }));

        // Update the current state
        setCurrentAppointments(fetchedData);
        setPageCount(totalPageCount);
      }
    );
  }, [clickedButton, current_page]);

  return (
    <>
      <Header />
      <PageHeader pagename="Physician Profile" />
      <section className="main-sidebar user-profile">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <PhysicianProfileSidebar />
            </div>
            <div className="col-lg-8">
              <div className="main-profile-content radius-20 p-4 patient-appointment_dv">
                <div className="main-headind d-flex align-items-center mb-3">
                  <div className="edit-btn back">
                    <div className="nav-anchor"></div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <h5 className="main-heading level-6 ps-3 main-heading-font dark-color mb-0">
                      My Consultations
                    </h5>
                    <div className="btn_consultation">
                      <button
                        className={
                          clickedButton === "upcoming" ? "active_btn" : ""
                        }
                        onClick={() => handleClick("upcoming")}
                      >
                        Upcoming
                      </button>
                      <button
                        className={
                          clickedButton === "current" ? "active_btn" : ""
                        }
                        onClick={() => handleClick("current")}
                      >
                        Current
                      </button>
                      <button
                        className={clickedButton === "past" ? "active_btn" : ""}
                        onClick={() => handleClick("past")}
                      >
                        Past
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {currentAppointments?.length > 0 ? (
                    currentAppointments.map((data, gindex) => (
                      <div className="col-lg-6 mt-4" key={gindex}>
                        <div
                          className={
                            clickedButton === "current"
                              ? "dark-bg doctor-detail-des main-profile-content radius-35 padding-profile"
                              : "doctor-detail-des main-profile-content radius-20 p-4"
                          }
                        >
                          <div className="d-flex align-items-center gap-3 mb-2">
                            <img
                              src={data?.patient_profile_image_url}
                              className="img-fluid profie_img"
                              alt=""
                            />
                            <div>
                              <h4
                                className={
                                  clickedButton === "current"
                                    ? "main-heading-font text-white mb-0"
                                    : "main-heading-font dark-color mb-0"
                                }
                              >
                                {data?.patient_title}
                              </h4>
                              <h5 className="mb-0 extra-color-9">
                                {data?.physician_degree_title}
                              </h5>
                            </div>
                          </div>
                          <div className="mt-4">
                            <Link
                              className={
                                clickedButton === "current"
                                  ? "detail-physician-btn d-flex align-items-center justoify-content-center w-100 text-white extra-bg-16"
                                  : "detail-physician-btn"
                              }
                              to={`/physician-consultation-detail/${data?.booking_id}`}
                            >
                              <span>
                                <i className="fa-regular fa-calendar"></i>
                              </span>
                              {data?.booking_day}{data?.booking_date} -
                              {data?.booking_time}
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <Norecord />
                  )}
                </div>
                <Pagination
                  pageCount={pageCount}
                  setPageCount={setPageCount}
                  current_page={current_page}
                  setCurrent_page={setCurrent_page}
                  apicall={currentAppointments}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PhysicianMyConsultations;
